import { useNavigate, Link } from 'react-router-dom';
import * as C from './styles';
import { useForm, FormActions } from '../../../../FormContext';
import {Theme} from '../../theme';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';
import Body from '../../../../assets/humanbody2.png';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { uploadRefs } from '../../../../data/Orcamento';
import { Alert } from 'react-bootstrap';


const FormStep3 = () => {
    const navigate = useNavigate();
    const { state, dispatch } = useForm();
    const [firstName, setFirstName] = useState('');
    const [unmedida, setUnmedida] = useState('Centímetros');
    const [show, setShow] = useState(false);
    const [refs, setRefs] = useState(['']);
    const [uploading, setUploading] = useState(false);
 
    useEffect(() => {
        if(state.email === '' || state.celphone === '' || state.name === '' || state.birth === ''){
            navigate('/orcamento/contato');
        } else {
            dispatch({
                type: FormActions.setCurrentStep,
                payload: 3
            })
            const splited = state.name.split(" ");
            setFirstName(splited[0]);
        }
    }, []);

    const handleDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
        dispatch({
            type: FormActions.setDescription,
            payload: e.target.value
        });
    }

    const handleBodyPart = (e: ChangeEvent<HTMLSelectElement>) => {
        dispatch({
            type: FormActions.setBodyPart,
            payload: e.target.value
        });
    }

    const handleClickBodyPart = (value: string) => {
        dispatch({
            type: FormActions.setBodyPart,
            payload: value
        });
    }

    const handleImageAdd = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const formData = new FormData (e.currentTarget);
        const file = formData.get('file') as File;

        if(file && file.size > 0){
            setUploading(true);
            let result = await uploadRefs(file, state.celphone);
            setUploading(false);

            if(result){
                let x = refs;
                x.push(result);
                setRefs(x);
            }
        }
    }

    const setReferences = async () => {
        dispatch({
            type: FormActions.setRefs,
            payload: refs
        })
    }


    const handleSide = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: FormActions.setMemberSide,
            payload: e.target.value
        })
    }

    const handleSize = (e: ChangeEvent<HTMLInputElement>) => {
        dispatch({
            type: FormActions.setEstimatedSize,
            payload: e.target.value
        })
    }

    const handleUnMedida = async () => {
        dispatch({
            type: FormActions.setUnMedida,
            payload: unmedida
        })
    }

    const handleNextStep = async () => {
        if(state.bodyPart !== '' && state.description !== '' && refs.length > 0){
            await setReferences();
            await handleUnMedida();
            navigate('/orcamento/data');
        } else {
            setShow(true);
        }
    }

    return (
        <Theme>
            <C.Container>
                <p className='ms-1'>{'Passo ' + state.currentStep + '/4'}</p>
                <h1>Qual é sua ideia?</h1>
                <p className='ms-1'>Descreva sua ideia da forma mais detalhada possivel.</p>
                <hr/>
                <div className="col-md-7 col-lg-9 mb-2">
                    <label htmlFor="description" className="mb-2 ms-4">
                        Descrição
                    </label>
                    <textarea 
                        id="description"
                        className="form-control"
                        value={state.description}
                        rows={4}
                        onChange={handleDescription}
                    ></textarea>
                </div>
                <div className="col-md-7 col-lg-9 mb-2">
                    <label htmlFor="bodypart" className="mb-4 ms-4 mt-4">
                        Parte do corpo
                    </label>
                    <div className='col-12 d-flex justify-content-center'>
                        <div className='bodypart'>
                            <div className={`bodymember ${state.bodyPart === 'orelha' ? 'ativo' : ''}`} style={{marginTop: 24, marginLeft: 43}} onClick={() => handleClickBodyPart('orelha')}>Orelha</div>
                            <div className={`bodymember ${state.bodyPart === 'pescoco' ? 'ativo' : ''}`} style={{marginTop: 60, marginLeft: 184}} onClick={() => handleClickBodyPart('pescoco')}>Pescoço</div>
                            <div className={`bodymember ${state.bodyPart === 'ombro' ? 'ativo' : ''}`} style={{marginTop: 83, marginLeft: 0}} onClick={() => handleClickBodyPart('ombro')}>Ombro</div>
                            <div className={`bodymember ${state.bodyPart === 'peito' ? 'ativo' : ''}`} style={{marginTop: 105, marginLeft: 223}} onClick={() => handleClickBodyPart('peito')}>Peito</div>
                            <div className={`bodymember ${state.bodyPart === 'costas' ? 'ativo' : ''}`} style={{marginTop: 128, marginLeft: -10}} onClick={() => handleClickBodyPart('costas')}>Costas</div>
                            <div className={`bodymember ${state.bodyPart === 'braco' ? 'ativo' : ''}`} style={{marginTop: 145, marginLeft: 232}} onClick={() => handleClickBodyPart('braco')}>Braço</div>
                            <div className={`bodymember ${state.bodyPart === 'antebraco' ? 'ativo' : ''}`} style={{marginTop: 190, marginLeft: -12}} onClick={() => handleClickBodyPart('antebraco')}>Antebraço</div>
                            <div className={`bodymember ${state.bodyPart === 'pulso' ? 'ativo' : ''}`} style={{marginTop: 234, marginLeft: 232}} onClick={() => handleClickBodyPart('pulso')}>Pulso</div>
                            <div className={`bodymember ${state.bodyPart === 'mao' ? 'ativo' : ''}`} style={{marginTop: 267, marginLeft: 54}} onClick={() => handleClickBodyPart('mao')}>Mão</div>
                            <div className={`bodymember ${state.bodyPart === 'dedo' ? 'ativo' : ''}`} style={{marginTop: 290, marginLeft: 180}} onClick={() => handleClickBodyPart('dedo')}>Dedo</div>
                            <div className={`bodymember ${state.bodyPart === 'coxa' ? 'ativo' : ''}`} style={{marginTop: 314, marginLeft: 23}} onClick={() => handleClickBodyPart('coxa')}>Coxa</div>
                            <div className={`bodymember ${state.bodyPart === 'coxatras' ? 'ativo' : ''}`} style={{marginTop: 332, marginLeft: 205}} onClick={() => handleClickBodyPart('coxatras')}>Coxa atrás</div>
                            <div className={`bodymember ${state.bodyPart === 'joelho' ? 'ativo' : ''}`} style={{marginTop: 378, marginLeft: 205}} onClick={() => handleClickBodyPart('joelho')}>Joelho</div>
                            <div className={`bodymember ${state.bodyPart === 'panturrilha' ? 'ativo' : ''}`} style={{marginTop: 430, marginLeft: -10}} onClick={() => handleClickBodyPart('panturrilha')}>Panturrilha</div>
                            <div className={`bodymember ${state.bodyPart === 'canela' ? 'ativo' : ''}`} style={{marginTop: 476, marginLeft: 210}} onClick={() => handleClickBodyPart('canela')}>Canela</div>
                            <div className={`bodymember ${state.bodyPart === 'pe' ? 'ativo' : ''}`} style={{marginTop: 518, marginLeft: 128}} onClick={() => handleClickBodyPart('pe')}>Pé</div>
                            <img className='bodyimage' src={Body} />
                        </div>                        
                    </div>
                </div>
                <div className='col-12 d-flex  flex-wrap justify-content-around mt-4'>
                    <div className='col-12 col-md-6'>
                        <select className="form-select col-6" aria-label="Default select example" onChange={handleBodyPart}>
                            <option selected>Selecione</option>
                            <option value="Antebraco" selected={state.bodyPart === 'Antebraco' ? true : false}>Antebraço</option>
                            <option value="Braco" selected={state.bodyPart === 'Braco' ? true : false}>Braço</option>
                            <option value="Canela" selected={state.bodyPart === 'Canela' ? true : false}>Canela</option>
                            <option value="Costas" selected={state.bodyPart === 'Costas' ? true : false}>Costas</option>
                            <option value="Coxa" selected={state.bodyPart === 'Coxa' ? true : false}>Coxa</option>
                            <option value="Coxatras" selected={state.bodyPart === 'Coxatras' ? true : false}>Coxa atrás</option>
                            <option value="Dedo" selected={state.bodyPart === 'Dedo' ? true : false}>Dedo</option>
                            <option value="Joelho" selected={state.bodyPart === 'Joelho' ? true : false}>Joelho</option>
                            <option value="Mao" selected={state.bodyPart === 'Mao' ? true : false}>Mão</option>
                            <option value="Ombro" selected={state.bodyPart === 'Ombro' ? true : false}>Ombro</option>
                            <option value="Orelha" selected={state.bodyPart === 'Orelha' ? true : false}>Orelha</option>
                            <option value="Panturrilha" selected={state.bodyPart === 'Panturrilha' ? true : false}>Panturrilha</option>
                            <option value="Pe" selected={state.bodyPart === 'Pe' ? true : false}>Pé</option>
                            <option value="Peito" selected={state.bodyPart === 'Peito' ? true : false}>Peito</option>
                            <option value="Pescoco" selected={state.bodyPart === 'Pescoco' ? true : false}>Pescoço</option>
                            <option value="Pulso" selected={state.bodyPart === 'Pulso' ? true : false}>Pulso</option>
                        </select>
                    </div>
                    <div className='col-12 col-md-6 d-flex justify-content-evenly mt-3 align-items-center'>
                        <div className="form-check">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="esquerdo" onChange={handleSide}/>
                            <label className="form-check-label" htmlFor="inlineRadio1">Esquerdo</label>
                        </div>
                        <div className="form-check ">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="direito" onChange={handleSide}/>
                            <label className="form-check-label" htmlFor="inlineRadio2">Direito</label>
                        </div>
                        <div className="form-check ">
                            <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="ambos" onChange={handleSide}/>
                            <label className="form-check-label" htmlFor="inlineRadio3">Ambos</label>
                        </div>
                    </div>                   
                </div>
                <div className='col-12'>
                    <label className='ms-4 mb-2 mt-4'>
                        Tamanho estimado
                        <OverlayTrigger
                            placement='top'
                            overlay={
                                <Tooltip>
                                    Se você não tem uma régua por perto, pode usar outro objeto como unidade de medida.<br/> Ex.: 1,5 Isqueiro Bic G;<br/>0,5 Caneta Bic
                                </Tooltip>
                            }
                        >
                            <i className='bi bi-question-circle-fill tooltipicon'/>
                        </OverlayTrigger>
                    </label>                    
                    <div className='col-9 col-sm-6 col-lg-4'>
                        <InputGroup className="mb-3">
                            <Form.Control aria-label="Text input with dropdown button" type='number' onChange={handleSize} />

                            <DropdownButton
                                variant="outline-dark"
                                title={unmedida}
                                id="input-group-dropdown-2"
                                align="end"
                                onChange={handleUnMedida}
                            >
                                <Dropdown.Item className='py-1 px-2' value='Centímetros' onClick={() => setUnmedida('Centímetros')}>Centímetros</Dropdown.Item>
                                <Dropdown.Item className='py-1 px-2' value='Cartão' onClick={() => setUnmedida('Cartão - 8,7cm')}>Cartão - 8,7cm</Dropdown.Item>
                                <Dropdown.Item className='py-1 px-2' value='Caneta Bic' onClick={() => setUnmedida('Caneta Bic - 15cm')}>Caneta Bic - 15cm</Dropdown.Item>
                                <Dropdown.Item className='py-1 px-2' value='Isqueiro Bic G' onClick={() => setUnmedida('Isqueiro Bic G - 8cm')}>Isqueiro Bic G - 8cm</Dropdown.Item>
                                <Dropdown.Item className='py-1 px-2' value='Isqueiro Bic P' onClick={() => setUnmedida('Isqueiro Bic P - 6,3cm')}>Isqueiro Bic P - 6,3cm</Dropdown.Item>
                            </DropdownButton>
                        </InputGroup>
                    </div>
                </div>
                <div className='col-12'>
                    <label htmlFor="file" className="ms-4 mb-2 mt-4">Referências</label>
                    <form method="POST" onSubmit={handleImageAdd}>
                        <div className="input-group mb-4">
                            <input type="file" className="form-control" name="file" id="file" aria-describedby="inputGroupFileAddon04" aria-label="Upload"/>
                            <button className="btn btn-outline-dark" type="submit" id="inputGroupFileAddon04" disabled={uploading ? true : false}>{uploading ? 'Enviando...' : 'Adicionar'}</button>
                        </div>
                    </form> 
                    <div className='d-flex'>
                        {refs && refs.map((ref,key) => (
                            <div key={key} className=''>
                                <img src={ref} className='img-fluid'/>
                            </div>
                        ))
                        }
                    </div>
                </div>
                <div className="d-flex mt-4 justify-content-between">
                    <Link to="/orcamento/contato" className="back ms-1"><i className="bi bi-reply-fill"></i></Link>
                    <button className="btn btn-dark ms-1" onClick={handleNextStep}>Avançar <i className="bi bi-chevron-right"></i></button>
                </div>
                {show === true &&
                    <div className="mt-4">
                        <Alert variant="warning" onClose={() => setShow(false)} dismissible className='p-2'>
                            Por favor, informe a descrição, lugar do corpo e uma referencia.
                        </Alert>
                    </div>
                }
            </C.Container>
        </Theme>
    );
}

export default FormStep3;